import React from "react";
import Modal from "./Modal";
import Button from "./Button";

function ConfirmDialog({ title, message, confirmLabel = "Confirm", onConfirm, onCancel, danger = false }) {
  return (
    <Modal
      title={title}
      onClose={onCancel}
      footer={
        <>
          <Button variant="secondary" onClick={onCancel}>
            Cancel
          </Button>
          <Button variant={danger ? "danger" : "primary"} onClick={onConfirm}>
            {confirmLabel}
          </Button>
        </>
      }
    >
      <p>{message}</p>
    </Modal>
  );
}

export default ConfirmDialog;
